import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import style from './FavNotificationsTile-style.scss';

const FavNotificationsTileItem = ({ item }) => {
    return (
        <div className={style.item}>
            <a href={item.pdpURL}><img className={style.itemImage} src={item.firstPhotoWebPath} /></a>
        </div>
    );
};

FavNotificationsTileItem.propTypes = {
    item: PropTypes.object.isRequired
};

export default createFragmentContainer(FavNotificationsTileItem,
    {
        item: graphql`
            fragment FavNotificationsTileItem_item on Item {
                pdpURL
                firstPhotoWebPath(size: thumb)
            }
        `
    }
);



// WEBPACK FOOTER //
// ./src/components/FavNotifications/FavNotificationsTileItem.jsx